import { takeLatest, call, put } from "redux-saga/effects";

import API_ENDPOINTS from "@services/apiConfig";
import axios from 'axios';
import AuthManager from "@services/AuthManager";

export const actionTypes = {
    fetchReseller: 'PARTNER/FETCH_RESELLER_INITIATED',
    fetchResellerSuccess: 'PARTNER/FETCH_RESELLER_SUCCESS',
    fetchResellerFailed: 'PARTNER/FETCH_RESELLER_FAILED',
};

export const actions = {
    fetchReseller: () => ({ type: actionTypes.fetchReseller }),
};

const initialState = {
    fetching: false,
    fetched: false,
    data: {},
    errMsg: null,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.fetchReseller: {
            return {
                ...state,
                fetching: true,
            };
        }
        case actionTypes.fetchResellerSuccess: {
            return {
                ...state,
                fetched: true,
                fetching: false,
                data: action.payload,
            };
        }
        case actionTypes.fetchResellerFailed: {
            return {
                ...state,
                fetched: true,
                errMsg: action.payload,
            };
        }
        default:
            return state;
    }
};

export const selectors = {
    isFetching: (state) => state.partnerApp.reseller.fetching,
    isFetched: (state) => state.partnerApp.reseller.fetched,
    getLogo: (state) => state.partnerApp.reseller.data && state.partnerApp.reseller.data.icon_url || '', 
    getName: (state) => state.partnerApp.reseller.data && state.partnerApp.reseller.data.name || '',
    getPlanDetails: (state) => state.partnerApp.reseller.data&&  state.partnerApp.reseller.data.plan && state.partnerApp.reseller.data.plan.plan_details || [] ,
    getSecondaryPlanDetails: (state) => state.partnerApp.reseller.data.secondary_plan && state.partnerApp.reseller.data.secondary_plan.plan_details || [],
    getResellerEmail: (state) => state.partnerApp.reseller.data.email || '',
    getKamDetails: (state) => state.partnerApp.reseller.data || '',
    getBankingLogo: ( state) => state.partnerApp.reseller.data && state.partnerApp.reseller.data.banking_partner_logo_url || '',
    getShowIncentives : (state) => state.partnerApp.reseller.data && state.partnerApp.reseller.data.show_incentives_tab || false,
    getShowUsers: (state) => state.partnerApp.reseller.data && state.partnerApp.reseller.data.show_users_tab || false,
};

function* fetchWorker() {
  const reseller_uuid = AuthManager.getResellerId();
  try {
    const response = yield call(
      [axios, 'get'],
      API_ENDPOINTS.RESELLER({ reseller_uuid })
    )
    yield put({ type: actionTypes.fetchResellerSuccess, payload: response.data.reseller });
  } catch (err) {
    const errResponse = yield err.response;
  }
}

export function* saga() {
    yield takeLatest(actionTypes.fetchReseller, fetchWorker);
}